module.exports = __webpack_public_path__ + "static/media/cq_nuovo_appuntamento.59cb68e3.svg";